import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";

import {
  TemplateBadge,
  PlaylistContainer,
  PlaylistName,
  PlaylistFooter,
  Username,
  ImageElement,
  EmptyStateContainer,
  EmptyStateIcon,
  PlayIcon,
  ListLines,
  ListLine,
} from "./PlaylistItem.styles";

import { ReactComponent as TemplatesIcon } from "../../../assets/icons/templates.svg";
import { formatTemplateBadge } from "../../../utils/utils";

const PlaylistItem = ({ playlist, onPlaylistItemClick, priority }) => {
  const [shouldLoadVideo, setShouldLoadVideo] = useState(priority);

  const { ref: containerRef, inView } = useInView({
    threshold: 0.01,
    rootMargin: "400px",
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView && !shouldLoadVideo) {
      const timer = setTimeout(
        () => {
          setShouldLoadVideo(true);
        },
        priority ? 0 : 100,
      );
      return () => clearTimeout(timer);
    }
  }, [inView, shouldLoadVideo, priority]);

  const isEmpty = !playlist?.collections || playlist.collections.length === 0;

  const firstTemplate = playlist?.collections?.[0];

  const posterUrl =
    firstTemplate?.output?.video?.posterUrl ||
    firstTemplate?.input?.image?.resizedImage?.url ||
    firstTemplate?.input?.image?.url;

  const aspectRatio = isEmpty
    ? 1 / 1.5
    : (firstTemplate?.input?.image?.resizedImage?.width ?? 1) /
      (firstTemplate?.input?.image?.resizedImage?.height ?? 1.5);

  const renderContent = () => {
    if (isEmpty) {
      return (
        <EmptyStateContainer>
          <EmptyStateIcon>
            <PlayIcon />
            <ListLines>
              <ListLine />
              <ListLine />
              <ListLine />
            </ListLines>
          </EmptyStateIcon>
        </EmptyStateContainer>
      );
    }

    return <ImageElement src={posterUrl} />;
  };

  return (
    <PlaylistContainer
      ref={containerRef}
      style={{ aspectRatio }}
      onClick={() => onPlaylistItemClick(playlist)}
    >
      <TemplateBadge>
        <TemplatesIcon width={14} height={14} />
        {formatTemplateBadge(playlist?.numOfCollections || 0)}
      </TemplateBadge>

      {renderContent()}

      <PlaylistFooter>
        <PlaylistName>{playlist?.name}</PlaylistName>
        {playlist?.username && <Username>@{playlist?.username}</Username>}
      </PlaylistFooter>
    </PlaylistContainer>
  );
};

export default React.memo(PlaylistItem);
